import { EmissorContractStatus } from '../../types/contractStatus';
export { isInlineSvgIcon } from '../../utils/isInlineSvgIcon';
const PAT_SUFFIX = 'PAT';
function resolveProductName(product) {
    if (!product.productName) {
        return product.productId;
    }
    if (product.productIsPat && !new RegExp(`\\b${PAT_SUFFIX}\\b`, 'i').test(product.productName)) {
        return `${product.productName} ${PAT_SUFFIX}`;
    }
    return product.productName;
}
export function mapEmissorProductToContractedBenefitItem(product) {
    return {
        id: product.contractProductId || product.productId,
        name: resolveProductName(product),
        icon: product.productIcon ?? null,
    };
}
export function mapEmissorProductsToContractedBenefitItems(products) {
    return [...products]
        .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        .map(mapEmissorProductToContractedBenefitItem);
}
export function isEmissorContractActive(status) {
    return (status ?? '').toUpperCase() === EmissorContractStatus.ACTIVATED;
}
